import React from "react";
import TableDataList from "./TableDataList";
interface ListWrapperProps {
  data: any[];
  context: string;
  onRowAction?: (action: string, row: any) => void;
  selectedRowItem?: any | null;
  onRowSelect?: (row: any | null, index: number) => void;
  currentRecord?: (index: number) => void;
  pagination?: { pageIndex: number; pageSize: number };
  setPagination?: (pagination: { pageIndex: number; pageSize: number }) => void;
  globalFilter?: string;
  setGlobalFilter?: (filter: string) => void;
  rowCount?: number;
  loading?: boolean;
  // Why the list failed to load, if it did; shown in place of the empty row.
  error?: string | null;
  // Drives the search field rendered in the table's toolbar. Owned by the page
  // so the keyword outlives the table remounting between loads.
  search?: {
    input: string;
    applied: string;
    // The search the rows currently shown were fetched with.
    listFilter: string;
    minLength: number;
    canApply: boolean;
    onInputChange: (value: string) => void;
    onApply: () => void;
    onClear: () => void;
  };
}

const ListWrapper: React.FC<ListWrapperProps> = ({
  data,
  context,
  onRowAction = (action, row) => console.log(`${action} row:`, row), // Default handler
  selectedRowItem,
  onRowSelect,
  currentRecord,
  pagination,
  setPagination,
  globalFilter,
  setGlobalFilter,
  rowCount,
  loading,
  error,
  search,
}) => {
  return (
    <TableDataList
      context={context}
      data={data}
      handleRowAction={onRowAction}
      selectedRowItem={selectedRowItem}
      setCurrentRecord={currentRecord}
      pagination={pagination}
      setPagination={setPagination}
      globalFilter={globalFilter}
      setGlobalFilter={setGlobalFilter}
      rowCount={rowCount}
      loading={loading}
      error={error}
      search={search}
    />
  );
};

export default ListWrapper;
